import requestModule from '@/application/libs/requestModule'

export default {
    getGeradorAnalyticsStatus() {
        return requestModule.postRequest('getGeradorAnalyticsStatus', {}, "Row")
            .then(response => response.dataset?.data);
    },
};
